import { useTranslate } from "../../translate";
import PhoneCallLogoImg from "../../images/PhoneCallLogo.jpg";
import MessageLogo from "../../images/MessageLogo.jpg";
import EditComputerLogo from "../../images/EditComputerLogo.jpg";
import "./VoiceableServiceModalBody.scss";

const VoiceableServiceModalBody = () => {
  const i18n = useTranslate();
  const { t, isRtl } = i18n;
  return (
    <div className="voiceable-service-modal-body" dir={isRtl() ? "rtl" : "ltr"}>
      <div className="voiceable-service-body-container">
        <div className="header">
          <div className="header-title">
            {t("VoiceableServiceModalBody.header.title")}
          </div>
        </div>
        <div className="seamless-exp-content">
          <div className="logo">
            <img src={PhoneCallLogoImg} alt="seamless-exp" />
          </div>
          <div className="content">
            <div className="title">
              {t("VoiceableServiceModalBody.seamlessExperienceSection.title")}
            </div>
            <div className="steps">
              <p>
                <strong>
                  {t(
                    "VoiceableServiceModalBody.seamlessExperienceSection.step1.label"
                  )}
                </strong>
                {t(
                  "VoiceableServiceModalBody.seamlessExperienceSection.step1.desc"
                )}
              </p>
              <p>
                <strong>
                  {t(
                    "VoiceableServiceModalBody.seamlessExperienceSection.step2.label"
                  )}
                </strong>
                {t(
                  "VoiceableServiceModalBody.seamlessExperienceSection.step2.desc"
                )}
                <strong>
                  {t(
                    "VoiceableServiceModalBody.seamlessExperienceSection.step2.strong2.text"
                  )}
                </strong>
                {t(
                  "VoiceableServiceModalBody.seamlessExperienceSection.step2.desc2"
                )}
              </p>
              <p>
                <strong>
                  {t(
                    "VoiceableServiceModalBody.seamlessExperienceSection.step3.label"
                  )}
                </strong>
                {t(
                  "VoiceableServiceModalBody.seamlessExperienceSection.step3.desc"
                )}
              </p>
            </div>
          </div>
        </div>
        <div className="hassle-free-shopping-content">
          <div className="logo">
            <img src={MessageLogo} alt="hassle-free-shopping" />
          </div>
          <div className="content">
            <div className="title">
              {t("VoiceableServiceModalBody.seamlessExperienceSection.title")}
            </div>
            <ul>
              <li>
                {t(
                  "VoiceableServiceModalBody.hassleFreeShoppingSection.listItem1"
                )}
              </li>
              <li>
                {t(
                  "VoiceableServiceModalBody.hassleFreeShoppingSection.listItem2"
                )}
              </li>
              <li>
                {t(
                  "VoiceableServiceModalBody.hassleFreeShoppingSection.listItem3"
                )}
              </li>
              <li>
                {t(
                  "VoiceableServiceModalBody.hassleFreeShoppingSection.listItem4"
                )}
              </li>
              <li>
                {t(
                  "VoiceableServiceModalBody.hassleFreeShoppingSection.listItem5"
                )}
              </li>
            </ul>
          </div>
        </div>
        <div className="special-assistance-content">
          <div className="logo">
            <img src={EditComputerLogo} alt="special-assistance" />
          </div>
          <div className="content">
            <div className="title">
              {t("VoiceableServiceModalBody.specialAssistanceSection.title")}
            </div>
            <ul>
              <li>
                {t(
                  "VoiceableServiceModalBody.specialAssistanceSection.listItem1"
                )}
              </li>
              <li>
                {t(
                  "VoiceableServiceModalBody.specialAssistanceSection.listItem2"
                )}
              </li>
              <li>
                {t(
                  "VoiceableServiceModalBody.specialAssistanceSection.listItem3"
                )}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VoiceableServiceModalBody;
